// This dynamic import is required by Module Federation: it defers
// execution until the webpack shared-module scope has been initialized,
// which lets host and remotes negotiate shared singleton deps
// (react, react-dom, redux, antd, etc.) before any app code runs.
import('./bootstrap');
